import type { QueryClient } from '@tanstack/react-query';
import { sqlImportKeys, type SqlImport } from './entity';

export function setSqlImportCache(qc: QueryClient, workspaceId: number, sqlImport: SqlImport): void {
  qc.setQueryData(sqlImportKeys.detail(workspaceId, sqlImport.id), sqlImport);
}

/** @public */
export function getSqlImportCache(qc: QueryClient, workspaceId: number, id: string): SqlImport | undefined {
  return qc.getQueryData<SqlImport>(sqlImportKeys.detail(workspaceId, id));
}

export function removeSqlImportCache(qc: QueryClient, workspaceId: number, id: string): void {
  // Only inactive: the detail page that triggered the delete still observes
  // the slot while it navigates away; removing an observed query forces a
  // doomed refetch of the just-deleted import.
  qc.removeQueries({ queryKey: sqlImportKeys.detail(workspaceId, id), type: 'inactive' });
}

export function invalidateSqlImportLists(qc: QueryClient, workspaceId: number): void {
  void qc.invalidateQueries({ queryKey: sqlImportKeys.lists(workspaceId) });
}
